export default "__VITE_ASSET__f65053df__"